module.exports = {
  "country": "IE",
  "artist": "Paul Harrigton, Charlie McGettingan",
  "song": "Rock'n'Roll Kids",
  "year": "1994",
  "place": "1",
  "spotify": "4qVX2nHuFlVNp6AOVrDBGb"
};